import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './UserProfile.css';

const UserProfile = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    setIsOpen(false);
    navigate('/login');
  };

  const handleProfile = () => {
    setIsOpen(false);
    // Navigate to profile page when implemented
    alert('Profile page coming soon!');
  };

  const handleSettings = () => {
    setIsOpen(false);
    navigate('/settings/shopify');
  };

  return (
    <div className="user-profile" ref={dropdownRef}>
      <button 
        className="profile-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="User menu"
        aria-expanded={isOpen}
      >
        <div className="avatar">
          <span className="avatar-text">JD</span>
        </div>
        <div className="user-info">
          <span className="user-name">John Doe</span>
          <span className="user-role">Admin</span>
        </div>
        <svg 
          className={`dropdown-arrow ${isOpen ? 'rotated' : ''}`}
          width="12" 
          height="12" 
          viewBox="0 0 12 12"
          fill="none"
        >
          <path 
            d="M2.5 4.5L6 8L9.5 4.5" 
            stroke="currentColor" 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="profile-dropdown">
          <div className="dropdown-header">
            <div className="avatar-large">
              <span className="avatar-text">JD</span>
            </div>
            <div className="dropdown-user-info">
              <span className="dropdown-name">John Doe</span>
              <span className="dropdown-email">john@thriftlyst.com</span>
            </div>
          </div>

          <div className="dropdown-divider"></div>

          <div className="dropdown-menu">
            <button className="dropdown-item" onClick={handleProfile}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 8C9.65685 8 11 6.65685 11 5C11 3.34315 9.65685 2 8 2C6.34315 2 5 3.34315 5 5C5 6.65685 6.34315 8 8 8Z" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M3 14C3 11.7909 5.23858 10 8 10C10.7614 10 13 11.7909 13 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
              <span>My Profile</span>
            </button>

            <button className="dropdown-item" onClick={handleSettings}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M13 8C13 8.5 13.1 8.9 13.2 9.3L14.5 10.2L13.5 12L12 11.5C11.6 11.9 11.1 12.2 10.6 12.4L10.3 14H8.7L8.4 12.4C7.9 12.2 7.4 11.9 7 11.5L5.5 12L4.5 10.2L5.8 9.3C5.7 8.9 5.7 8.5 5.8 8.1L4.5 7.2L5.5 5.4L7 5.9C7.4 5.5 7.9 5.2 8.4 5L8.7 3.4H10.3L10.6 5C11.1 5.2 11.6 5.5 12 5.9L13.5 5.4L14.5 7.2L13.2 8.1C13.1 8.5 13 8.7 13 8Z" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
              <span>Settings</span>
            </button>

            <div className="dropdown-divider"></div>

            <button className="dropdown-item logout-item" onClick={handleLogout}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 14H3C2.44772 14 2 13.5523 2 13V3C2 2.44772 2.44772 2 3 2H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                <path d="M11 11L14 8L11 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M14 8H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
              <span>Logout</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserProfile;
